import { LocaleId } from '@shared/models/language.model';
// TODO: update all refs to LocaleMapId to use LocaleId instead

export { LocaleId as LocaleMapId } from '@shared/models/language.model';

export const enum MapClientKey {
  Default = 'default',
  Google = 'google',
  Gaode = 'gaode',
}

export const LOCALE_MAP_CLIENT_MAP: { [localeId: number]: MapClientKey } = {
  [LocaleId.ChinaChinese]: MapClientKey.Gaode,
  [LocaleId.ChinaEnglish]: MapClientKey.Google,
  [LocaleId.IndiaEnglish]: MapClientKey.Google,
  [LocaleId.UkEnglish]: MapClientKey.Google,
  /* Commenting for December release  12/17/2021. 
  [LocaleId.ItalyItalian]: MapClientKey.Google,
  [LocaleId.ItalyEnglish]: MapClientKey.Google,
  [LocaleId.PolandPolish]: MapClientKey.Google,
  [LocaleId.PolandEnglish]: MapClientKey.Google,
  [LocaleId.SwedenSwedish]: MapClientKey.Google,
  [LocaleId.SwedenEnglish]: MapClientKey.Google,
  [LocaleId.FinlandFinnish]: MapClientKey.Google,
  [LocaleId.FinlandEnglish]: MapClientKey.Google,
  [LocaleId.NorwayNorwegian]: MapClientKey.Google,
  [LocaleId.NorwayEnglish]: MapClientKey.Google,  */
};

export interface MapClientScripts {
  name: string;
  src: string;
}

/**
 * Interface that represents a coordinate
 */
export interface LatLong {
  latitude: number;
  longitude: number;
}

export interface MapTypeModel {
  key: MapClientKey;
  label: string;
}

/**
 * Interface that represents the base layer for the widget map
 */
export interface MapBaseLayer {
  Streets: any;
  Imagery: any;
  userLocaleId: number;
}

export type MapBaseLayerFn = (userLocaleId: LocaleId) => MapBaseLayer | null;
